import type { JSX } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { sobActualsModalTranslation } from '../../../translation'

import styles from './SobActualsRecalcPrompt.module.scss'

export type SobActualsRecalcPromptMode = 'recalculate' | 'cancel'

type SobActualsRecalcPromptProps = {
  mode: SobActualsRecalcPromptMode
  onRecalculate: () => void
  onCancelRecalculate: () => void
  onResetChanges: () => void
}

export const SobActualsRecalcPrompt = ({
  mode,
  onRecalculate,
  onCancelRecalculate,
  onResetChanges,
}: SobActualsRecalcPromptProps): JSX.Element => {
  const isRecalculate = mode === 'recalculate'

  return (
    <div className={styles.root}>
      <i className={`${styles.icon} kbase kbase-warning-alt`} aria-hidden />
      <span className={styles.message}>
        <Translation
          text={
            isRecalculate
              ? sobActualsModalTranslation.recalcNotice
              : sobActualsModalTranslation.recalcCancelNotice
          }
          span
        />
      </span>
      {isRecalculate && (
        <Button
          className={styles.button}
          color="danger"
          variant="text"
          size="sm"
          onClick={onResetChanges}
        >
          <Translation text={sobActualsModalTranslation.resetChanges} span />
        </Button>
      )}
      <Button
        className={styles.button}
        color="primary"
        size="sm"
        onClick={isRecalculate ? onRecalculate : onCancelRecalculate}
      >
        <Translation
          text={
            isRecalculate
              ? sobActualsModalTranslation.recalculate
              : sobActualsModalTranslation.cancelRecalculate
          }
          span
        />
      </Button>
    </div>
  )
}
